import { ICountryCurrencyMap } from './currency_service_interface';

export const CURRENCY_SYMBOLS: ICountryCurrencyMap= {
    CAD: 'C$',
    NOK: 'Kr.',
    USD: '$',
    EUR: '€',
    GBP: '£',
    DKK: 'Kr.',
    SEK: 'kr',
    RON: 'RON',
    BRL: "R$"
};

export const CURRENCY_DEFAULT_FORMAT: string = '{symbol}{#}2{#},{#}.{#}%s%v';

export const CURRENCY_FORMAT_SYMBOL_SELECTOR: string = '{symbol}';

export const CURRENCY_FORMAT_NAME: string = 'currency_format';

export const WALLET_TOKEN_PROPERTY_KEY: string = 'walletData';